import React, { useState } from 'react';
import logo from '../../images/laughing_tiger_logo.svg'

const NAV_ITEMS = [
  { href: '#intro', label: 'Home' },
  { href: '#about', label: 'About Me' },
  { href: '#carrier', label: 'Carrier' },
  { href: '#skills', label: 'Skills' },
  { href: '#qualifications', label: 'Qualifications' },
  { href: '#works', label: 'Works' },
  { href: '#socialmedia', label: 'Social Media' },
  { href: '#blog', label: 'Blog' },
];

function Header() {
  const [openMenu, setOpenMenu] = useState(false);

  const handleMenuOpen = () => {
    setOpenMenu(!openMenu);
  };

  return (
    <div className='header w-full z-50 top-0 py-3 sm:py-5 absolute'>
      <div className="flex items-center justify-between">
        <a href="#intro" className="app-in app-in-1">
          <img src={logo} className="mx-4 w-24 lg:w-48 lg:mx-0" alt="Laughing Tiger" />
        </a>
        <nav className="relative">
          <div className="max-w-screen-xl px-4 mx-auto">
            <div className="flex items-center justify-between">
              <div className="lg:hidden">
                <div className="relative my-2">
                  <button
                    onClick={handleMenuOpen}
                    aria-expanded={openMenu}
                    aria-label="メニューを開く"
                    className="navbar-burger bounce-hover flex items-center text-white p-3"
                  >
                    <svg className="block h-4 w-4 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h30v2H0v-2z"></path>
                    </svg>
                  </button>
                </div>
              </div>
              <ul className="hidden font-medium mt-0 mr-6 space-x-8 text-sm lg:flex lg:flex-row">
                {NAV_ITEMS.map((item) => (
                  <li key={item.href} className="nav-in">
                    <a
                      className="nav-underline cursor-pointer pt-0.5 font-header font-semibold uppercase text-white"
                      href={item.href}
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </nav>
      </div>

      {/* モバイルメニュー */}
      <ul
        className={`lg:hidden overflow-hidden bg-black/80 backdrop-blur transition-[max-height,opacity] duration-500 ease-out-expo ${
          openMenu ? 'max-h-[32rem] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        {NAV_ITEMS.map((item) => (
          <li key={item.href}>
            <a
              className="block px-6 py-3 font-header text-sm font-semibold uppercase text-white"
              href={item.href}
              onClick={() => setOpenMenu(false)}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
export default Header;
